

import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { PATIENT_LIMITS } from 'src/app/shared/app.constants';
import { HeightUnit } from '../../components/header/components/interface/interface';
import { StorageBrowser } from '../storage.service';
import { UserService } from '../user.service';
@Injectable({
  providedIn: 'root',
})
export class ConversionLengthService {
  public preferredLengthUnit: string;
  constructor(private userService: UserService, private storageBrowser: StorageBrowser) {
    const currUser = this.userService.currentUser.getValue() || {};
    this.preferredLengthUnit = currUser.preferredLengthUnit || HeightUnit.IN;
  }


   /**
   * Converts value from cm (server) to user's preferred unit.
   * Example: 180 cm → 70.87 in (if preferred unit is in)
   */
   fromServer(valueInCm: number): number {
    return this.preferredLengthUnit === HeightUnit.IN
      ? valueInCm / 2.54
      : valueInCm;
  }

  /**
   * Converts value from user's preferred unit to cm (for sending to server).
   * Example: 70.87 in → 180 cm (if preferred unit is in)
   */
  toServer(valueInUserUnit: number): number {
    return this.preferredLengthUnit === HeightUnit.IN
      ? valueInUserUnit * 2.54
      : valueInUserUnit;
  }

  /**
   * Optional: formatted value for display (e.g., "180 cm" or "70.87 in")
   */
  formatFromServer(valueInCm: number): string {
    return `${this.formatValueFromServer(valueInCm)} ${this.preferredLengthUnit}`;
  }
  formatValueFromServer(valueInCm: number): string {
    const converted = this.fromServer(valueInCm);
    if (typeof converted !== 'number' || !Number.isFinite(converted)) {
      return '';
    }

    return converted.toFixed(2);
  }

  setPatientValidators(form: any, field: 'height' | 'neckSize'): void {
    const limits: any = PATIENT_LIMITS[field];
    const control = form.get(field);
    if (!control) return;

    // Values are always stored in cm, so validators operate on cm bounds.
    if (this.preferredLengthUnit === HeightUnit.IN) {
      const { min, max } = this.getInBoundsInCm(limits.IN);
      control.setValidators([Validators.min(min), Validators.max(max)]);
    } else if (this.preferredLengthUnit === HeightUnit.CM) {
      control.setValidators([Validators.min(limits.CM.MIN), Validators.max(limits.CM.MAX)]);
    }
    control.updateValueAndValidity();
  }

  /**
   * Converts the imperial limits to cm. Supports both feet/inches limits
   * (e.g. height) and single-inch limits (e.g. neck size).
   */
  private getInBoundsInCm(inLimits: any): { min: number; max: number } {
    const toCm = (limit: any) =>
      typeof limit === 'number'
        ? limit * 2.54
        : limit.feet * 30.48 + limit.inches * 2.54;
    return { min: toCm(inLimits.MIN), max: toCm(inLimits.MAX) };
  }




}
